import './App.css';

import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import React from "react";
import Index from "./sites";
import Version from './sites/version';
import ProjectTasks from "./sites/projecttasks";
import Projects from './sites/projects';
import Login from './sites/login';
import Users from './sites/users';
import Project from './sites/project';
import TasksByStatus from './sites/tasksByStatus';
import SprintSiteOverview from './sites/sprintsiteoverview';
import SprintDetailedSite from './sites/sprintDetailedSite';
import OpenSprintSiteOverview from './sites/openSprintSiteOverview';
import BacklogOverviewSite from './sites/BacklogOverviewSite';
import TaskDetailedSite from './sites/TaskDetailedSite';
import TagOverviewSite from './sites/tagOverviewSite';
import TagDetailSite from './sites/tagDetailSite';
import OpenTagOverviewSite from "./sites/OpenTagOverviewSite";
import MilestoneOverviewSite from './sites/MilestoneOverviewSite';
import MilestoneDetailSite from './sites/MilestoneDetailed';
import Profile from './sites/profile';
import UserDetail from './sites/userdetail';

class App extends React.Component {

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <Router>
            <Switch>
              {/* In process */}
              <Route exact path="/" component={Index} />
              {/* TODO */}
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)" component={Project} />
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Tasks" component={ProjectTasks} />
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Tasks/Status/:taskStatusID(\b[0-9]\b)" component={TasksByStatus} /> {/*Skipped making a different link for now */}
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Task/:taskID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)" component={TaskDetailedSite} />
              <Route exact path="/Version" component={Version} />
              <Route exact path="/Projects" component={Projects} />
              <Route exact path="/Login" component={Login} />
              <Route exact path="/Users" component={Users} />
              <Route exact path="/Users/:useruuid(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)" component={UserDetail} />
              <Route exact path="/Profile" component={Profile} />
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Sprints" component={SprintSiteOverview} />
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Sprint/:sprintUUID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)" component={SprintDetailedSite} />
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Sprints/Open" component={OpenSprintSiteOverview} />
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Sprints/Backlog" component={BacklogOverviewSite} />
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Tags" component={TagOverviewSite} />
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Tags/Unreleased" component={OpenTagOverviewSite} />
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Tag/:tagUUID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)" component={TagDetailSite} />
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Milestones" component={MilestoneOverviewSite} />
              <Route exact path="/Project/:projectID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/Milestone/:milestoneUUID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)" component={MilestoneDetailSite} />
            </Switch>
          </Router>
        </header>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js